import apiClient from './apiClient'
import type { PriceListItem } from '@/types'

interface PriceListResponse {
  data: PriceListItem[]
  message: string
  success: boolean
}

class PriceListService {
  /**
   * Get available price list items.
   *
   * Each billing frequency is its own set of products in CRM, with its own
   * ChargeBee ids, so a fortnightly product is only in the fortnightly list.
   * Omitted, the backend returns the weekly list.
   */
  async getPriceListItems(billingFrequency?: number): Promise<PriceListItem[]> {
    const query = billingFrequency ? `?billing_frequency=${billingFrequency}` : ''
    const response = await apiClient.get(`/api/auth/price-list-items${query}`)
    return (response as unknown as PriceListResponse).data || []
  }

  /**
   * The price lists for several frequencies, merged. For looking up products a
   * customer already has, which can be on subscriptions of different
   * frequencies. Product ids are unique per frequency, so nothing overlaps.
   */
  async getPriceListItemsForFrequencies(frequencies: number[]): Promise<PriceListItem[]> {
    const lists = await Promise.all(frequencies.map(f => this.getPriceListItems(f)))
    return lists.flat()
  }
}

export default new PriceListService()
